// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3NbhF","content":"GlobalSearch_content__frCCB"};